const CONTENT_COUNT_KEYS = [
  'total_videos',
  'total_documents',
  'total_assessments',
  'total_surveys',
];

export const EMPTY_COURSE_APPROVAL_MESSAGE =
  'This course has no content yet. Please create at least one module and add a video, document, assessment, or survey before sending it for approval.';

export const courseHasApprovableContent = (course) => {
  const summary = course?.course_summary || {};
  return CONTENT_COUNT_KEYS.some((key) => Number(summary[key] || 0) > 0);
};
